import type { MemeContext, MemeFormatDef } from './memeTypes';

export const MEME_FORMATS: MemeFormatDef[] = [
  {
    id: 'surrender',
    label: 'Terms of Surrender',
    fireBackLabel: 'Counterattack',
    available: (ctx) => Boolean(ctx.winner && ctx.loser),
  },
  {
    id: 'conscription',
    label: 'Conscription Notice',
    available: (ctx) => Boolean(ctx.team),
  },
  {
    id: 'operation',
    label: 'Operation Battle Map',
    available: (ctx) => Boolean(ctx.team && (ctx.winner || ctx.countyName)),
  },
  {
    id: 'mia',
    label: 'M.I.A.',
    available: (ctx) => Boolean(ctx.team && ctx.isZeroLand),
  },
  {
    id: 'declaration',
    label: 'Declaration of War',
    fireBackLabel: 'Accepted',
    available: (ctx) => Boolean(ctx.team && ctx.nextGame),
  },
  {
    id: 'dispatch',
    label: 'Front Line Dispatch',
    available: (ctx) => Boolean(ctx.team || ctx.winner),
  },
];

export function availableFormats(ctx: MemeContext): MemeFormatDef[] {
  return MEME_FORMATS.filter((f) => f.available(ctx));
}

/** Operation codenames — never "Maize Storm". */
const OP_WORDS = [
  'LANDFALL',
  'HORIZON',
  'GRIDLOCK',
  'TIPOFF',
  'FRONTIER',
  'KEYSTONE',
  'IRONCLAD',
  'NORTHSTAR',
  'SUNBELT',
  'RIVERBEND',
  'HIGHLAND',
  'CROSSROADS',
];

export function pickOperationName(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0;
  const word = OP_WORDS[Math.abs(h) % OP_WORDS.length]!;
  return word;
}
